import React, { useState } from "react";
import SectionHeader from "./SectionHeader";
import { playbooks } from "../mock";
import * as Icons from "lucide-react";
import { ChevronRight } from "lucide-react";

const Playbooks = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="playbooks" className="relative px-6 lg:px-10 py-20 border-t border-[#1c2533]">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          num="06 // RUNBOOKS"
          title="SOC PLAYBOOKS"
          subtitle="SOP // INVESTIGATION // ESCALATION"
        />

        <div className="grid lg:grid-cols-12 gap-4">
          <div className="lg:col-span-4 space-y-2">
            {playbooks.map((p, i) => {
              const Ico = Icons[p.icon] || Icons.BookOpen;
              const isActive = active === i;
              return (
                <button
                  key={p.title}
                  onClick={() => setActive(i)}
                  className={`w-full text-left border p-4 transition-all flex items-center gap-3 ${
                    isActive
                      ? "border-cyan-400 bg-[#0c1620]"
                      : "border-[#1c2533] bg-[#0c1118] hover:border-[#2a3a52]"
                  }`}
                >
                  <div
                    className={`w-10 h-10 grid place-items-center border ${
                      isActive
                        ? "border-cyan-400 text-cyan-400"
                        : "border-[#2a3a52] text-slate-300"
                    }`}
                  >
                    <Ico size={18} strokeWidth={1.5} />
                  </div>
                  <div className="flex-1">
                    <div className="font-mono text-[10px] tracking-[0.18em] text-slate-500">
                      PB-{String(i + 1).padStart(3, "0")}
                    </div>
                    <div
                      className={`font-mono text-[12px] tracking-[0.1em] font-semibold ${
                        isActive ? "text-cyan-400" : "text-slate-100"
                      }`}
                    >
                      {p.title}
                    </div>
                  </div>
                  <ChevronRight
                    size={16}
                    className={isActive ? "text-cyan-400" : "text-slate-600"}
                  />
                </button>
              );
            })}
          </div>

          <div className="lg:col-span-8 border border-[#1c2533] bg-[#0c1118] corner-brackets relative">
            <div className="flex items-center justify-between px-5 py-3 border-b border-[#1c2533] bg-[#0a0e14]">
              <div className="font-mono text-[11px] tracking-[0.2em] text-cyan-400">
                {playbooks[active].title}
              </div>
              <div className="font-mono text-[10px] tracking-[0.18em] text-slate-500">
                STEPS: {playbooks[active].steps.length}
              </div>
            </div>
            <div className="p-6 space-y-3">
              {playbooks[active].steps.map((s, i) => (
                <div
                  key={i}
                  className="flex items-start gap-4 p-3 border border-[#1c2533] bg-[#0a0e14] hover:border-cyan-400/60 transition-colors"
                >
                  <div className="font-mono text-cyan-400 text-sm font-bold w-7 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="text-slate-200 text-[14px] leading-relaxed">
                    <span className="text-cyan-500/70 mr-2">→</span>
                    {s}
                  </div>
                </div>
              ))}
              <div className="mt-4 pt-4 border-t border-[#1c2533] flex items-center justify-between">
                <span className="font-mono text-[10px] tracking-[0.18em] text-slate-500">
                  FRAMEWORK: <span className="text-cyan-400">MITRE ATT&CK</span>
                </span>
                <span className="font-mono text-[10px] tracking-[0.18em] text-emerald-400">
                  ● VALIDATED
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Playbooks;
